var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "security_svg2__a",
    x1: 46.5,
    x2: 161.9,
    y1: 167.26,
    y2: 25.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#security_svg2__a",
    id: "security_svg2__c",
    x1: 36.06,
    x2: 151.46,
    y1: 158.76,
    y2: 17.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#security_svg2__a",
    id: "security_svg2__d",
    x1: 50.5,
    x2: 165.9,
    y1: 170.52,
    y2: 28.82
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#security_svg2__a",
    id: "security_svg2__e",
    x1: 26.45,
    x2: 141.85,
    y1: 150.93,
    y2: 9.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#security_svg2__a",
    id: "security_svg2__f",
    x1: 42.98,
    x2: 158.38,
    y1: 164.4,
    y2: 22.7
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100.11 90.72c-3.68 0-6.67 2.98-6.67 6.67 0 2.66 1.56 4.95 3.82 6.02v8.1c0 1.57 1.27 2.85 2.85 2.85s2.85-1.27 2.85-2.85v-8.1a6.66 6.66 0 0 0 3.82-6.02c0-3.68-2.98-6.67-6.67-6.67",
    style: {
      fill: "url(#security_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.15 43.42c-12.25-4.85-21.98-13.78-27.39-25.15-1.47-3.09-4.65-5.09-8.1-5.09H64.33c-3.45 0-6.63 2-8.1 5.09-5.41 11.37-15.13 20.3-27.39 25.15-3.44 1.36-5.66 4.64-5.66 8.35v17.35c0 22.74 6.63 45.21 19.18 64.97 12.67 19.95 31.03 36.63 53.09 48.22l.36.19c1.31.69 2.75 1.03 4.18 1.03s2.87-.34 4.18-1.03l.36-.19c22.06-11.59 40.42-28.27 53.09-48.22 12.55-19.76 19.18-42.23 19.18-64.97V51.77c0-3.71-2.22-6.99-5.66-8.35Zm-.04 25.69c0 21.66-6.32 43.07-18.29 61.92-12.14 19.12-29.75 35.1-50.93 46.24l-.36.19c-.96.51-2.11.51-3.07 0l-.36-.19c-21.18-11.13-38.79-27.12-50.93-46.24-11.97-18.85-18.29-40.26-18.29-61.92V51.76c0-1.36.81-2.56 2.06-3.05 13.6-5.38 24.41-15.32 30.43-27.99.53-1.12 1.69-1.84 2.96-1.84h71.33c1.26 0 2.42.72 2.96 1.84 6.03 12.67 16.84 22.61 30.43 27.99a3.25 3.25 0 0 1 2.06 3.05z",
    style: {
      fill: "url(#security_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42 96.13c-1.53-.35-3.06.62-3.4 2.15-8.67 38.35-35.07 71.61-72.44 91.25l-8.68 4.56c-.56.29-1.23.29-1.79 0l-8.68-4.56c-37.42-19.67-63.84-52.99-72.47-91.41a2.84 2.84 0 0 0-3.4-2.15c-1.53.34-2.5 1.87-2.15 3.4 9 40.05 36.47 74.75 75.38 95.2l8.68 4.56c1.11.58 2.33.87 3.54.87s2.43-.29 3.54-.87l8.68-4.56c38.84-20.42 66.3-55.05 75.34-95.03.35-1.53-.62-3.06-2.15-3.4Z",
    style: {
      fill: "url(#security_svg2__d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.03 32.57c-15.2-1.6-27.15-12.27-29.06-25.94-.53-3.78-3.78-6.63-7.55-6.63H52.58c-3.78 0-7.02 2.85-7.55 6.63-1.91 13.67-13.86 24.34-29.06 25.94-3.85.41-6.76 3.66-6.76 7.57V70.7c0 4.44.23 8.93.68 13.35a2.857 2.857 0 0 0 2.83 2.56c.1 0 .2 0 .29-.02 1.56-.16 2.7-1.56 2.54-3.12-.43-4.22-.65-8.52-.65-12.76V40.15c0-.97.73-1.81 1.66-1.91 17.8-1.88 31.83-14.55 34.1-30.82.14-1 .94-1.72 1.91-1.72h94.84c.97 0 1.77.72 1.91 1.72 2.28 16.27 16.3 28.94 34.1 30.82.93.1 1.66.94 1.66 1.91v30.56c0 4.2-.22 8.45-.64 12.63-.16 1.56.98 2.96 2.54 3.12s2.96-.98 3.12-2.54c.44-4.37.67-8.81.67-13.21V40.15c0-3.91-2.9-7.16-6.75-7.57Z",
    style: {
      fill: "url(#security_svg2__e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.6 71.04h-4.68V57.45c0-15.34-12.48-27.81-27.81-27.81S72.3 42.12 72.3 57.45v13.59h-4.68c-4.99 0-9.05 4.06-9.05 9.05v40.75c0 4.99 4.06 9.05 9.05 9.05h64.98c4.99 0 9.05-4.06 9.05-9.05V80.09c0-4.99-4.06-9.05-9.05-9.05M77.99 57.45c0-12.2 9.92-22.12 22.12-22.12s22.12 9.92 22.12 22.12v13.59H77.99zm57.97 63.4c0 1.85-1.51 3.36-3.36 3.36H67.62c-1.85 0-3.36-1.51-3.36-3.36V80.1c0-1.85 1.51-3.36 3.36-3.36h64.98c1.85 0 3.36 1.51 3.36 3.36z",
    style: {
      fill: "url(#security_svg2__f)",
      strokeWidth: 0
    }
  }));
};
export default SvgSecurity;